import * as yup from 'yup';

export const dataSourceFormValidation = yup.object().shape({});
